import { Injectable } from '@angular/core';
import { MenuEnum } from '../../shared/enum/menu-enum';

@Injectable({
  providedIn: 'root'
})

export class HeaderService {
  menuFlag = MenuEnum.HOME;
  submenuFlag = null;

  constructor() {
  }

  carregarMenu(menuFlag) {
    this.menuFlag = menuFlag;
    this.submenuFlag = null;
  }

  carregarSubMenu(menuFlag, submenuFlag) {
    this.menuFlag = menuFlag;
    this.submenuFlag = submenuFlag;
  }
}
